import themeActionsTypes from '../actionTypes/themeActionsTypes';

const initialStore = {
  darkTheme: false
};

const reducer = (state = initialStore, { type, payload }) => {
  switch (type) {
    case themeActionsTypes.SET_THEME:
      return {
        ...state,
        darkTheme: payload
      };
    default:
      return state;
  }
};

export default reducer;
